import { render } from "./dual-hero.vue?vue&type=template&id=231ad115"
import script from "./dual-hero.vue?vue&type=script&lang=js"
export * from "./dual-hero.vue?vue&type=script&lang=js"

import exportComponent from "/Users/emilyyork/Shopify/clients/sneak-fr1/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__